<template>
    <div class="booking-page" data-page="1">
        <h2>{{ $t("Booking summary information") }}</h2>

        <fieldset>
            <div id="summary">
                <h3>{{ $t("Booking status") }}: {{ $t("Provisional") }}</h3>

                <!-- Booking info -->
                <div class="row heading">
                    <div class="title">
                        {{ $t("Holiday details for booking ref.") }}
                        <strong> {{ getBookingDetails.bookingId }} </strong>
                    </div>
                    <div class="value">
                        <router-link to="/#appTop">&gt;&gt;</router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="title">
                        {{ $t("Accommodation") }}:
                        <strong>
                            {{ getBookingDetails.accommodation }}
                        </strong>
                    </div>
                    <div class="value">
                        1
                    </div>
                    <div class="value">
                        {{ getCurrency.symbol
                        }}{{ getBookingDetails.accommodationPrice }}
                    </div>
                    <div class="value">
                        <strong
                            >{{ getCurrency.symbol
                            }}{{ getBookingDetails.accommodationPrice }}</strong
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="title">
                        {{ $t("Arrival") }}:
                        <strong>{{
                            ISO2Uk(getBookingDetails.BookedArrivalDate)
                        }}</strong>
                    </div>
                </div>
                <div class="row">
                    <div class="title">
                        {{ $t("Departure") }}:
                        <strong>{{
                            ISO2Uk(getBookingDetails.BookedDeptDate)
                        }}</strong>
                    </div>
                </div>

                <!-- Customer Information -->
                <div class="row heading">
                    <div class="title">
                        <strong>{{ $t("Customer information") }}</strong>
                    </div>
                    <div class="value">
                        <router-link to="/guest-details#appTop"
                            >&gt;&gt;</router-link
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="title">
                        {{ $t("Name") }}:
                        <strong
                            >{{ getBookingDetails.customer.Name }}
                            {{ getBookingDetails.customer.LastName }}</strong
                        >, DOB: {{ getBookingDetails.customer.DOB }}
                    </div>
                </div>
                <div class="row">
                    <div class="title">
                        {{ $t("Address") }}:
                        {{ getBookingDetails.customer.House }}
                        {{ getBookingDetails.customer.Street }}
                        {{ getBookingDetails.customer.Locality }}
                        {{ getBookingDetails.customer.Town }}
                        {{ getBookingDetails.customer.County }}
                        {{ getBookingDetails.customer.Country }}
                        {{ getBookingDetails.customer.Postcode }}
                    </div>
                </div>

                <!-- Companions -->
                <div
                    class="row heading"
                    v-if="getBookingDetails.companions.length > 0"
                >
                    <div class="title">
                        <strong>{{ $t("Companions") }}</strong>
                    </div>
                    <div class="value">
                        <router-link to="/guest-details#appTop"
                            >&gt;&gt;</router-link
                        >
                    </div>
                </div>
                <div
                    class="row"
                    v-for="(companion, index) in getBookingDetails.companions"
                    :key="index"
                >
                    <div class="title">
                        {{ companion.Name }} {{ companion.LastName }} -
                        {{ companion.DOB }}
                    </div>
                </div>

                <!-- Holiday Extras -->
                <div class="row heading" v-if="bookedHireItems.sum">
                    <div class="title">
                        <strong>{{ $t("Holiday extras") }}</strong>
                    </div>
                    <div class="value">
                        <router-link to="/extras#appTop">&gt;&gt;</router-link>
                    </div>
                </div>
                <div
                    class="row"
                    v-for="(bookedHireItem, index) in bookedHireItems.items"
                    :key="index"
                >
                    <div class="title">
                        {{ bookedHireItem.Item }}
                    </div>
                    <div class="value">
                        {{ bookedHireItem.Qty }}
                    </div>
                    <div class="value">
                        {{ getCurrency.symbol }}{{ bookedHireItem.Price }}
                    </div>
                    <div class="value">
                        {{ getCurrency.symbol }}{{ bookedHireItem.Total }}
                    </div>
                </div>
                <div class="row" v-if="bookedHireItems.sum > 0">
                    <div class="title"></div>
                    <div class="value">
                        <strong
                            >{{ getCurrency.symbol
                            }}{{ bookedHireItems.sum }}</strong
                        >
                    </div>
                </div>

                <!-- Ferries -->
                <div
                    class="row heading"
                    v-if="getBookingDetails.ferries.ferry_option == 'ferry'"
                >
                    <div class="title">
                        <strong>{{ $t("Ferries") }}</strong>
                    </div>
                    <div class="value">
                        <router-link to="/travel-and-insurance#appTop"
                            >&gt;&gt;</router-link
                        >
                    </div>
                </div>
                <div v-if="getBookingDetails.ferries.ferry_option == 'ferry'">
                    <div
                        class="row"
                        v-for="(ferry_line,
                        index) in getBookingDetails.additional_lines"
                        :key="index"
                    >
                        <div class="title">
                            {{ ferry_line }}
                        </div>
                    </div>
                </div>

                <!-- Discounts -->
                <div
                    class="row heading"
                    v-if="
                        getBookingDetails.transport_discount != '' ||
                            (getBookingDetails.discounts.referals_text != '' &&
                                getBookingDetails.discounts.referals_discount !=
                                    '') ||
                            getBookingDetails.discounts.lone_parents_discount !=
                                '' ||
                            getBookingDetails.discounts.singles_and_couples !=
                                '' ||
                            getBookingDetails.discounts
                                .promotional_discount_text != ''
                    "
                >
                    <div class="title">
                        <strong>{{ $t("Discounts") }}</strong>
                        <span style="font-size:80%">{{
                            $t(
                                "*Discounts other than own transport discount are  subject to validation"
                            )
                        }}</span>
                    </div>
                    <div class="value">
                        <router-link to="/discounts-and-offers#appTop"
                            >&gt;&gt;</router-link
                        >
                    </div>
                </div>
                <div
                    class="row"
                    v-if="getBookingDetails.transport_discount != ''"
                >
                    <div class="title">
                        {{ $t("Own Transport Discount") }}
                    </div>
                    <div class="value">
                        <strong
                            >{{ getCurrency.symbol
                            }}{{ getBookingDetails.transport_discount }}</strong
                        >
                    </div>
                </div>

                <div
                    class="row"
                    v-if="
                        getBookingDetails.discounts.referals_text != '' &&
                            getBookingDetails.discounts.referals_discount != ''
                    "
                >
                    <div class="title">
                        {{ $t("Tell A Friend Discount") }}
                        ({{ getBookingDetails.discounts.referals_text }};
                        <strong>
                            {{ getCurrency.symbol
                            }}{{
                                getBookingDetails.discounts.referals_discount
                            }}</strong
                        >
                        )
                    </div>
                </div>
                <div
                    class="row"
                    v-if="
                        getBookingDetails.discounts.lone_parents_discount != ''
                    "
                >
                    <div class="title">
                        {{ $t("Lone Parents Discount") }}
                        (<strong
                            >{{ getCurrency.symbol
                            }}{{
                                getBookingDetails.discounts
                                    .lone_parents_discount
                            }}</strong
                        >)
                    </div>
                </div>
                <div
                    class="row"
                    v-if="getBookingDetails.discounts.singles_and_couples != ''"
                >
                    <div class="title">
                        {{ $t("Singles And Couples") }}
                        (<strong
                            >{{ getCurrency.symbol
                            }}{{
                                getBookingDetails.discounts.singles_and_couples
                            }}</strong
                        >)
                    </div>
                </div>
                <div
                    class="row"
                    v-if="
                        getBookingDetails.discounts.promotional_discount_text !=
                            ''
                    "
                >
                    <div class="title">
                        {{ $t("Promotional Discount") }}
                        ({{
                            getBookingDetails.discounts
                                .promotional_discount_text
                        }};
                        <strong
                            >{{ getCurrency.symbol
                            }}{{
                                getBookingDetails.discounts.promotional_discount
                            }}</strong
                        >
                        )
                    </div>
                </div>

                <div class="row heading">
                    <div class="title" style="text-align:right">
                        {{ $t("Invoice total") }}:
                    </div>
                    <div class="value">
                        <strong
                            >{{ getCurrency.symbol }}{{ holidayTotal }}</strong
                        >
                    </div>
                </div>

                <!-- enquirySources -->
                <div v-if="!customerHasEnquirySource">
                    <label for="enquirySourceID">{{
                        $t("How did you hear about us")
                    }}</label>
                    <select
                        v-model="enquirySourceID"
                        @change="enqSourceChanged"
                        id="enquirySourceID"
                        required
                    >
                        <option value="">{{ $t("Please select...") }}</option>
                        <option
                            v-for="(source, index) in getLoadedEnquirySources"
                            :key="index"
                            :value="source.ID"
                            >{{ source.SourceDesc }}</option
                        >
                    </select>
                </div>

                <div class="checkbox">
                    <label
                        ><input type="checkbox" id="terms" v-model="terms" />
                        {{ $t("I have read the") }} </label
                    >&nbsp;<a
                        href="https://www.springharvestholidays.com/booking/terms-and-conditions"
                        target="_blank"
                    >
                        {{ $t("terms and conditions") }}
                    </a>
                </div>
            </div>
            <div class="continue_button">
                <button class="button blue" v-if="false">Phone me</button>
                &nbsp;

                <button
                    v-if="getCurrency.PriceTypeID != 9"
                    href="#"
                    class="button blue"
                    :disabled="hasInvalidFields"
                    @click.prevent="continueToPayment"
                >
                    {{ $t("Confirm and pay deposit") }} ({{ getCurrency.symbol
                    }}{{ getBookingDetails.deposit }})
                </button>

                <button
                    v-if="getCurrency.PriceTypeID == 9"
                    href="#"
                    class="button blue"
                    :disabled="hasInvalidFields"
                    @click.prevent="continueToPayment"
                >
                    {{ $t("Confirm") }}
                </button>
            </div>
        </fieldset>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            terms: false,
            enquirySourceID: null
        };
    },
    computed: {
        ...mapGetters([
            "getCurrency",
            "getBookingDetails",
            "getLoadedEnquirySources",
            "getLoadedExtras",
            "getStripePublicKey"
        ]),

        customerHasEnquirySource() {
            return (
                this.getBookingDetails.customer &&
                this.getBookingDetails.customer.EnqSourceID &&
                this.getBookingDetails.customer.EnqSourceID > 0
            );
        },

        hasInvalidFields() {
            console.log(
                "this.getBookingDetails.deposit",
                this.getBookingDetails.deposit
            );
            // Check if terms are accepted and deposit is set
            let isInvalid =
                !this.terms || this.getBookingDetails.deposit == null;

            // If customer doesn't have enquiry source, require selection
            if (!this.customerHasEnquirySource) {
                isInvalid =
                    isInvalid ||
                    !this.enquirySourceID ||
                    this.enquirySourceID === "";
            }

            return isInvalid;
        },
        bookedHireItems() {
            const Ids = this.getBookingDetails.hire_items[0];
            // console.log('Ids',Ids['232']);
            const arrKeys = Object.keys(Ids);
            // console.log('Ids',arrKeys);
            const allItems = this.getLoadedExtras;
            let bookedItems = [];
            let sum = 0;
            if (allItems != null) {
                allItems.forEach((element, index) => {
                    if (arrKeys.includes(element.Id)) {
                        let total = 0;
                        if (element.PerWeek == 1) {
                            total =
                                this.getBookingDetails.weeks *
                                element.Price *
                                Ids[element.Id];
                        } else {
                            total = Ids[element.Id] * element.Price;
                        }
                        sum += total;
                        bookedItems.push({
                            id: element.Id,
                            Item: element.Item,
                            PerWeek: element.PerWeek,
                            Price: element.Price,
                            Qty: Ids[element.Id],
                            Total: total,
                            Weeks: this.getBookingDetails.weeks
                        });
                        // console.log(element,index);
                    }
                });
            }

            return {
                items: bookedItems,
                sum: sum
            };
        },
        holidayTotal() {
            return (
                parseInt(this.getBookingDetails.accommodationPrice) +
                parseInt(this.bookedHireItems.sum) +
                parseInt(this.getBookingDetails.transport_discount)
            );
        }
    },
    mounted() {
        // If customer already has an EnqSourceID, set it in the store and component
        if (this.customerHasEnquirySource) {
            const existingEnqSourceID = this.getBookingDetails.customer
                .EnqSourceID;
            this.$store.commit("CHANGE_ENQUIRY_SOURCE", existingEnqSourceID);
            this.enquirySourceID = existingEnqSourceID;
        }
    },
    methods: {
        uk2ISO(d) {
            return (
                d.split("/")[2] + "-" + d.split("/")[1] + "-" + d.split("/")[0]
            );
        },
        ISO2Uk(d) {
            return (
                d.split("-")[2] + "/" + d.split("-")[1] + "/" + d.split("-")[0]
            );
        },
        continueToPayment() {
            this.saveToDatabase();
        },
        enqSourceChanged() {
            this.$store.commit("CHANGE_ENQUIRY_SOURCE", this.enquirySourceID);
        },
        saveToDatabase() {
            console.log("saveToDatabase");
            this.ajaxLoading = true;
            console.log("this.getBookingDetails", this.getBookingDetails);
            axios
                .post(process.env.VUE_APP_ROOT_URL + "booking/save-booking", {
                    bookingData: this.getBookingDetails
                })
                .then(response => {
                    this.ajaxLoading = false;
                    console.log("response.data", response.data);
                    if (response.data.saved) {
                        console.log("response.data.saved", response.data.saved);
                        if (this.getCurrency.PriceTypeID == 9) {
                            location.href =
                                process.env.VUE_APP_ROOT_URL +
                                "booking/agape/" +
                                response.data.hashedId;
                        } else {
                            console.log(
                                "(this.getStripePublicKey)",
                                this.getStripePublicKey
                            );
                            let stripe = Stripe(this.getStripePublicKey);
                            axios
                                .post(
                                    process.env.VUE_APP_ROOT_URL +
                                        `booking/stripe-session/` +
                                        this.getCurrency.currency.toLowerCase(),
                                    {
                                        bid: this.getBookingDetails.bookingId,
                                        locale: this.$i18n.locale,
                                        deposit: this.getBookingDetails.deposit
                                    }
                                )
                                .then(response => {
                                    // JSON responses are automatically parsed.
                                    // console.log('ajax',response.data);
                                    stripe.redirectToCheckout({
                                        sessionId: response.data.id
                                    });
                                })
                                // .then(response => {
                                //     // JSON responses are automatically parsed.
                                //     console.log('ajax',response.data);
                                // })
                                // .then(function (session) {
                                //   return stripe.redirectToCheckout({ sessionId: session.id });
                                // })
                                .catch(e => {
                                    // this.errors.push(e)
                                    console.log(e);
                                });
                        }
                    }
                })
                .catch(e => {
                    // this.errors.push(e)
                    console.log(e);
                    this.ajaxLoading = false;
                });
        }
    }
};
</script>

<style scoped>
.row {
    display: flex;
    border-bottom: 2px solid rgb(246 224 140);
}
.heading {
    background-color: rgb(246 224 140);
}
.heading .title {
    /* background-color:white; */
}
.heading .value {
    /* background-color:yellow; */
}
.title {
    flex: 1;
    padding: 3px;
}
.value {
    padding: 3px 10px;
    text-align: right;
    min-width: 55px;
}
a {
    color: #009fb8;
    font-weight: 900;
}
</style>
